/*
 * @Author: chengyu
 * @Date: 2022-08-16 15:40:01
 * @Description: 类型判断
 */
var _toString = Object.prototype.toString;
/**
 * @description: 判断值是否未某个类型
 */
export function is(val, type) {
    return _toString.call(val) === "[object " + type + "]";
}
/**
 * @description: 是否为对象
 */
export var isObject = function (val) {
    return val !== null && is(val, 'Object');
};
/**
 * @description: 是否为数组
 */
export function isArray(val) {
    return val && Array.isArray(val);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29yZS9pcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUgsSUFBTSxTQUFTLEdBQUcsTUFBTSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFFNUM7O0dBRUc7QUFDSCxNQUFNLFVBQVUsRUFBRSxDQUFDLEdBQVEsRUFBRSxJQUFZO0lBQ3ZDLE9BQU8sU0FBUyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxhQUFXLElBQUksTUFBRyxDQUFDO0FBQ3BELENBQUM7QUFFRDs7R0FFRztBQUNILE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxVQUFDLEdBQVE7SUFDL0IsT0FBTyxHQUFHLEtBQUssSUFBSSxJQUFJLEVBQUUsQ0FBQyxHQUFHLEVBQUUsUUFBUSxDQUFDLENBQUM7QUFDM0MsQ0FBQyxDQUFDO0FBRUY7O0dBRUc7QUFDSCxNQUFNLFVBQVUsT0FBTyxDQUFDLEdBQVE7SUFDOUIsT0FBTyxHQUFHLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUNuQyxDQUFDIn0=